// src/hooks/useInfoFeed.js
import axiosInstance from 'utils/axiosInstance';
import { useInfiniteQuery } from '@tanstack/react-query';

export default function useInfoFeed(selectedTopics = [], postFilter = 'all') {
  return useInfiniteQuery({
    queryKey: ['infoFeed', selectedTopics, postFilter],
    queryFn: ({ pageParam }) => {
      const params = { limit: 20 };

      if (pageParam) {
        params.score = pageParam.score;
        params.createdAt = pageParam.createdAt;
      }

      if (selectedTopics.length > 0) {
        params.topics = selectedTopics.join(',');
      }

      if (postFilter === 'following') {
        params.onlyFollowing = true;
      }

      return axiosInstance.get('/knovia/myInfo/infoFeed', { params })
        .then(res => res.data);
    },
    getNextPageParam: (last) => last.nextCursor ?? undefined,
    keepPreviousData: true, // prevents blinking
  });
}